export default "__VITE_ASSET__1M_8h96C__"